module.exports = __webpack_public_path__ + "static/media/Klok.dd9a69ef.mp3";